export const SET_CALIBRATION = 'SET_CALIBRATION'
export const SET_STATUS = 'SET_STATUS'
export const SET_AIMING_URLS = 'SET_AIMING_URLS'
export const SET_ALIGNMENTSPECS = 'SET_ALIGNMENTSPECS'
export const RESET_STATUS = 'RESET_STATUS'

export const SESSION_STEPSTATUS = 'SESSION_STEPSTATUS'

export const USER_ORDER_BY = 'user/orderBy'
export const USER_SORT_DIR = 'user/sortDir'
export const USER_DAYS = 'user/days'
export const USER_PAGE_SIZE = 'user/pageSize'
export const USER_SEARCH_TERM = 'user/searchTerm'
export const USER_FILTER_BY = 'user/filterBy'



// WEBPACK FOOTER //
// ./src/store/modules/calibration/types.js